<script lang="ts">
  import { Previous } from 'runed';
  import { flipSwaps } from '~/animations.svelte';

  type Props = {
    value: number | string;
    label: string;
    delay: number;
  };
  const props: Props = $props();

  const prev = new Previous(() => props.value);
</script>

<div class="stat">
  {#key props.value}
    <span
      class="stat-number"
      in:flipSwaps|global={{
        transition: 'in',
        duration: props.value === '-' ? 0 : 200,
        direction: (prev.current ?? 0) > props.value ? 'up' : 'down',
        delay: props.delay,
      }}
      out:flipSwaps={{
        transition: 'out',
        duration: props.value === '-' ? 0 : 200,
        direction: (prev.current ?? 0) > props.value ? 'up' : 'down',
        delay: props.delay,
      }}
    >
      {props.value}
    </span>
  {/key}
  <span>{props.label}</span>
</div>

<style lang="scss">
  .stat {
    display: flex;
    flex-direction: column;
    display: grid;
    .stat-number {
      grid-row: 1/2;
      grid-column: 1;
      font-size: 3rem;
      font-weight: bold;
      line-height: 1em;
    }
  }
</style>
